import React, { createContext, useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('rutex_auth_token') || null);
    const [loading, setLoading] = useState(true);

    // Initial load: parse user from localstorage if available
    useEffect(() => {
        const storedUser = localStorage.getItem('rutex_user');
        if (storedUser && token) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
                Sentry.setUser({
                    id: parsedUser.id,
                    email: parsedUser.email,
                    role: parsedUser.role || (parsedUser.roles && parsedUser.roles[0]?.name) || parsedUser.rol,
                });
            } catch (e) {
                console.error("Error parsing stored rutex_user:", e);
                setUser(null);
                Sentry.setUser(null);
            }
        } else {
            Sentry.setUser(null);
        }
        setLoading(false);
    }, [token]);

    const login = (userData, authToken) => {
        setToken(authToken);
        setUser(userData);
        localStorage.setItem('rutex_auth_token', authToken);
        localStorage.setItem('rutex_user', JSON.stringify(userData));
        Sentry.setUser({
            id: userData.id,
            email: userData.email,
            role: userData.role || (userData.roles && userData.roles[0]?.name) || userData.rol,
        });
    };

    const logout = () => {
        setToken(null);
        setUser(null);
        localStorage.removeItem('rutex_auth_token');
        localStorage.removeItem('rutex_user');
        Sentry.setUser(null);
    };

    const updateUser = (updatedFields) => {
        setUser(prev => {
            const updated = prev ? { ...prev, ...updatedFields } : updatedFields;
            localStorage.setItem('rutex_user', JSON.stringify(updated));
            if (updated) {
                Sentry.setUser({
                    id: updated.id,
                    email: updated.email,
                    role: updated.role || (updated.roles && updated.roles[0]?.name) || updated.rol,
                });
            }
            return updated;
        });
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, updateUser, loading, isAuthenticated: !!token }}>
            {children}
        </AuthContext.Provider>
    );
};
